AuthRoute = require 'mixins/authenticated-route'

App.SettingsBillingRoute = Em.Route.extend AuthRoute,
  beforeModelAuth: ->
    organization = @get('session').get('currentOrganization')
    @controllerFor('settings.billing').set('organization', organization)

  afterModel: ->
    Em.RSVP.hash(
      tariffs: @store.find('service')
      subscriptions: @store.find('service_subscription')
      billingOperations: @store.find('billing_operation')
      billingInfo: @store.find('billingInfo',0)
      invoices: @store.find('invoice')
    ).then (attrs) =>
      controller = @controllerFor('settings.billing')
      controller.setProperties(attrs)
